var _style, _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSynced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.Synced-st0 {\r\n\t\t\tdisplay: none;\r\n\t\t\tstroke: currentColor;\r\n\t\t\tstroke-miterlimit: 10;\r\n\t\t}\r\n\r\n\t\t.Synced-st1 {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\t.Synced-st2 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -344,
    y: -256.5,
    className: "Synced-st0",
    width: 700,
    height: 525
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Synced-st1",
    d: "M220.9-76.5c-18.4-102.3-107.4-180-214.9-180s-196.5,77.7-214.9,180C-286.2-58.4-344,10.6-344,93.5 c0,96.6,78.4,175,175,175h131.2V53.9h-87.5l131.2-175l131.2,175H49.6v214.6H181c96.6,0,175-78.4,175-175 C356,10.6,298.2-58.4,220.9-76.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Synced-st2",
    d: "M6,1.8c0.4,0,0.8,0.1,1.2,0.2c0.4,0.1,0.7,0.3,1,0.6c0.6,0.5,1,1.2,1.2,2l0,0.2l0.2,0.1 c0.6,0.1,1.1,0.5,1.5,0.9c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.2,0.6,0.2,0.9c0,0.7-0.3,1.4-0.8,1.9c-0.5,0.5-1.2,0.8-1.9,0.8H6.7 H5.2H3c-0.7,0-1.4-0.3-1.9-0.8C0.6,8.9,0.3,8.2,0.3,7.5c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.5,0.4-0.8c0.4-0.5,0.9-0.8,1.5-0.9 l0.2-0.1l0-0.2c0.1-0.8,0.5-1.5,1.2-2c0.3-0.3,0.6-0.5,1-0.6C5.2,1.9,5.6,1.8,6,1.8 M6,1.5c-1.8,0-3.4,1.3-3.7,3.1 C1,4.9,0,6.1,0,7.5c0,1.7,1.3,3,3,3h2.2h1.5H9c1.7,0,3-1.3,3-3c0-1.4-1-2.6-2.3-2.9C9.4,2.8,7.8,1.5,6,1.5L6,1.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "Synced-st2",
    points: "5.8,9.3 3.2,7.2 3.8,6.4 5.7,7.9 8.5,4.7 9.3,5.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynced);
export default __webpack_public_path__ + "static/media/Synced.e57443e1ac3982552e43e8a259e1b3c3.svg";
export { ForwardRef as ReactComponent };